import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessagePropType } from '../../../../prop-types/intl';

import style from './inputs.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

const instructionsLabel = <FormattedMessage defaultMessage='Instructions' description='otherShippingOptions.instructions' id='CcwFA0' />;

const updateInstructions = (data, value, updateOption) => {
  const newValue = {
    ...data,
    instructions: value,
  };
  updateOption({ id: 'safeplace', value: newValue });
};

const renderSafeplaceInput = (data, updateOption, updateInput) => {
  const { instructions } = data;
  return (
    <div className={style['single-input']}>
      <Input label={instructionsLabel} onBlur={(v) => updateOption(v)} onChange={(v) => updateInput(v)} value={instructions} />
    </div>
  );
};

export const SafeplaceInput = ({
  label,
  checked = false,
  onCheck = noop,
  optionData = emptyObject,
  updateOption = noop,
  updateInput = noop,
}) => (
  <div>
    <Checkbox checked={checked} label={label} onChange={onCheck} />
    {checked &&
      renderSafeplaceInput(
        optionData,
        (instructions) => updateInstructions(optionData, instructions, updateOption),
        (instructions) => updateInstructions(optionData, instructions, updateInput),
      )}
  </div>
);

SafeplaceInput.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.object,
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};
